// extracted by mini-css-extract-plugin
module.exports = {"button_align":"Product_button_align__1CD5e","button_gap":"Product_button_gap__1RYu0"};